import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { UserContext } from '../../../context';
import { getAnchors } from '../../Anchors/services';


function FanzoneRecommend(props) {
  const [anchor, setAnchor] = useState(null);
  const [friendAnchor, setFriendAnchor] = useState(null);
  const user = React.useContext(UserContext);
  const anchorSubscriptions =
    user.user && user.user.account.anchorSubscriptions;
  const hasSubscription =
    anchorSubscriptions &&
    !!anchorSubscriptions.find(
      (el) => parseInt(el.subCategory, 10) === parseInt(props.anchorId, 10)
    );

  useEffect(() => {
    getCurrentAnchors();
  }, []);

  const getCurrentAnchors = async() => {
    const { error, data } = await getAnchors();
    if (!error) {
      const { currentAnchors } = data.data;
      setAnchor(
        currentAnchors.find(
          (el) => parseInt(el.id, 10) === parseInt(props.anchorId, 10)
        )
      );
      if (hasSubscription) {
        setFriendAnchor(
          currentAnchors[Math.floor(Math.random() * currentAnchors.length)]
        );
      }
    }
  };

  const buildAnchorLink = (anchor) => {
    const baseRoute = '/naked-news-anchor';
    const nameArray = anchor.name.split(' ');
    let finalName = '';
    for (let i = 0; i < nameArray.length; i++) {
      finalName += `${nameArray[i]}-`;
    }

    return `${baseRoute}-${finalName.toLowerCase()}a${anchor.id}`;
  };

  return (
    <p className="calendar-checkout-text">
      {!props.failed ? 'Thank you for your purchase! Since you like' : 'In the meantime, since you like'}{' '}
      {anchor ? anchor.name.split(' ')[0] : 'this anchor'} you might want to
      check out her {hasSubscription ? 'friend\'s' : ''}{' '}
      <Link
        to={
          anchor ? buildAnchorLink(friendAnchor ? friendAnchor : anchor) : '/naked-news-anchors'
        }
      >
        fan zone page
      </Link>{' '}
      for exclusive videos and images as well as live shows.
    </p>
  );
}

export default FanzoneRecommend;
